import { Component, Input } from '@angular/core';

@Component({
    selector: 'lokos-label',
    templateUrl: './label.component.html',
    styleUrl: './label.component.scss',
    standalone: false
})
export class LabelComponent {
    @Input() label!: string;
    @Input() required = false;
    @Input() fontWeight = '';
}
